<template>
  <Card>
    <span slot="title">角色管理</span>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getRolesData)" class="fr">刷新</el-button>
    <div slot="content" class="rolewrap">
      <!-- 条件查询 -->
      <div class="search"> 
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="角色名称">
            <el-input v-model="searchForm.roleName" placeholder="请输入角色名称"/>
          </el-form-item>
          <!-- <el-form-item label="角色标识">
            <el-input v-model="searchForm.roleKey" placeholder="请输入角色标识"/>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getRolesData, searchForm)" >查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getRolesData, { roleName: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addRole">新增角色</el-button>
        <!-- <el-button icon="el-icon-delete" type="danger" @click="deleteRoleList">批量删除</el-button> -->
      </div>
      <!-- 角色列表 -->
      <el-table v-loading="loading" :data="roleList" ref="multipleTable"
        :max-height="tableHeight" @selection-change="val => $handleSelectionChange(val, true)" border>
        <!-- <el-table-column type="selection" width="50"> </el-table-column> -->
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="roleName" label="角色名称"/>
        <el-table-column prop="roleKey" label="角色标识"/>
        <el-table-column prop="status" label="角色状态">
          <template slot-scope="scope">
            {{scope.row.status == '0' ? '正常' : '停用'}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="150"/>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="editRole(scope.row)" >编辑</el-button>
            <el-button icon="el-icon-delete" type="danger" @click="deleteRole(scope.row)" >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="roleEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="角色名称" prop="roleName">
            <el-input v-model="editForm.roleName" placeholder="请输入角色名称"/>
          </el-form-item>
          <el-form-item label="角色标识" prop="roleKey">
            <el-input v-model="editForm.roleKey" placeholder="请输入角色标识"/>
          </el-form-item>
          <el-form-item label="角色排序" prop="roleSort">
            <el-input v-model="editForm.roleSort" placeholder="请输入角色等级"/>
          </el-form-item>
          <el-form-item label="菜单分配" prop="menuIds">
            <TreeSelect v-model="editForm.menuIds" :options="menuList" :normalizer="normalizer" multiple placeholder="请选择该角色可访问的菜单" />
          </el-form-item>
          <el-form-item label="角色状态" prop="status">
            <el-radio-group v-model="editForm.status">
              <el-radio :label="'0'">启用</el-radio>
              <el-radio :label="'1'">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增角色'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑角色'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getRolesData)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </Card>
</template>

<script lang="js">
import { roleList, roleEdit, roleDelete, roleAdd, roleInfo } from "@/api/role"; // 获取角色请求
import { menuList } from "@/api/menu"; // 获取菜单请求
// 引入树形选择
import TreeSelect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
  name: "Role",
  components: {"TreeSelect": TreeSelect},
  data() {
    return {
      loading: true, // 加载中
      searchForm: { roleName: null }, // 查询表单
      roleList: [], // 角色列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], // 被选中行
      menuList: [], // 菜单数组
      normalizer(obj) { // 键名转换，方法默认是label和children进行树状渲染
        return { id: obj.menuId, label: obj.menuName }
      },
      editFormRules: {
        roleName: [{required: true, message: "角色名称不能为空！", trigger: "blur"}],
        roleKey: [{required: true, message: "角色标识不能为空！", trigger: "change"}],
        roleSort: [{required: true, message: "角色排序不能为空！", trigger: "change"}],
        menuIds: [{required: true, message: "可访问菜单不能为空！", trigger: "change"}],
        status: [{required: true}],
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getRolesData(); // 请求角色列表
    this.getMenusData(); // 请求菜单列表
  },
  methods: {
    // 请求所有角色列表
    async getRolesData() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await roleList(params);
      if (code == 200) {
        this.total = total;
        this.roleList = rows;
      }
      this.loading = false;
    },
    // 请求所有菜单列表
    async getMenusData() {
      let params = { ...this.searchForm };
      let { data, code } = await menuList(params);
      if (code == 200) this.listToTree(data);
    },
    // 处理菜单id
    handleMenuIds() {
      let ids = [], params = JSON.parse(JSON.stringify(this.editForm));;
      params.menuIds.forEach(items => {
        ids.push(items);
        this.menuList.forEach(item => {
          if (items == item.menuId) item.children.forEach(child => { ids.push(child.menuId)});
          else item.children.forEach(child => {
            if (child.menuId == items) {
              let flag = true;
              ids.forEach(id => { if (id == child.parentId ) flag = false });
              if (flag == true) ids.push(child.parentId);
            }
          })
        })
      });
      params.menuIds = ids;
      return params;
    },
    // 链式结构转树形结构
    listToTree(list) {
      this.menuList = [];
      // 目录列表
      list.forEach(item => { if (item.menuType == "M") this.menuList.push(item) });
      // 菜单列表
      list.forEach(item => {
        if (item.menuType == "C") this.menuList.forEach(items => { if (item.parentId == items.menuId) items.children.push(item) });
      });
    },
    // 新增角色
    addRole() {
      this.dialogVisible = true;
      this.dialogTitle = "新增角色";
      this.editForm = { roleName: null, roleKey: null, roleSort: null, menuIds: [], status: '0' };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          roleAdd(this.handleMenuIds()).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增角色成功！");
            this.dialogVisible = false;
            this.$refresh(this.getRolesData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 编辑角色信息
    async editRole(row) {
      let { data, code } = await roleInfo(row.roleId);
      if (code == 200) {
        let ids = [];
        this.menuList.forEach(item => {
          item.checkedList = [];
          data.menuIds.forEach(items => {
            item.children.forEach(child => {
              if (child.menuId == items) item.checkedList.push(items);
            })
          })
        });
        this.menuList.forEach(item => {
          if (item.children.length === 0) {
            if (data.menuIds.includes(item.menuId)) {
              ids.push(item.menuId);
            }
          } else {
            if (item.checkedList.length == item.children.length) {
              ids.push(item.menuId);
            } else {
              ids = [...ids, ...item.checkedList];
            }
          }
        });
        data.menuIds = ids;
        this.editForm = data;
        this.dialogTitle = "编辑角色";
        this.dialogVisible = true;
      }
    },
    // 保存角色修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          roleEdit(this.handleMenuIds()).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("修改角色成功！");
            this.dialogVisible = false;
            this.$refresh(this.getRolesData);
            this.$refs['editForm'].resetFields();
          });
        } else return false;
      })
    },
    // 删除角色
    deleteRole(row) {
      this.$confirm('确认删除该角色？').then(_ => { this.del(row.roleId) }).catch(_ => {});
    },
    async del(id) {
      let { code } = await roleDelete(id);
      if (code == 200) this.$message.success("删除角色成功！");
      this.$refresh(this.getRolesData);
    },
    // 批量删除角色
    deleteRoleList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何角色");
      else {
        selected.forEach(item => { selectedId.push(item.roleId) });
        this.$confirm('确认删除该角色？').then(_ => { this.del(selectedId) }).catch(_ => {});
      }
    }
  },
};
</script>

<style lang="less" scoped>
.rolewrap {
  & > div:not(:last-child) {
    margin-bottom: 20px;
  }
  .roleEdit {
    .el-form-item {
      width: 460px;
    }
    /deep/.el-input, /deep/.el-form-item__content {
      width: 380px;
    }
  }
}
</style>